'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ExpandButton;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseButtons = require('@bibliocommons/base-buttons');

require('../styles/ExpandButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ExpandButton(_ref) {
  var expanded = _ref.expanded,
      handleToggle = _ref.handleToggle,
      renderLabel = _ref.renderLabel;

  return _react2.default.createElement(
    _baseButtons.BlueCaretArrowButton,
    { 'aria-expanded': expanded, className: 'cp-expand-button', handleClick: handleToggle, caretUp: expanded },
    renderLabel(expanded)
  );
}

ExpandButton.propTypes = {
  expanded: _react.PropTypes.bool.isRequired,
  handleToggle: _react.PropTypes.func.isRequired,
  renderLabel: _react.PropTypes.func
};

ExpandButton.defaultProps = {
  renderLabel: function renderLabel(expanded) {
    return expanded ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_show_less' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_show_more' });
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/expandable/lib/components/expand-button/components/ExpandButton.component.js
// module id = 1407
// module chunks = 1